export default __webpack_public_path__ + "static/media/Provider_taxonamy.ed43791b.svg";